import { createRouter, createWebHistory } from 'vue-router';
import mainRoutes from "@/router/main";
import svcRoutes from "@/router/svc";
import cscrRoutes from "@/router/cscr";
import mberSbsrRoutes from '@/router/mber-sbsr';
import sampleRoutes from "@/router/sample";
import AgencyRoutes from "@/router/agency";

let routes = [];

routes =
  routes
    .concat(mainRoutes)
    .concat(svcRoutes)
    .concat(cscrRoutes)
    .concat(mberSbsrRoutes)
    .concat(sampleRoutes)
    .concat(AgencyRoutes);


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
